export enum Theme {
    Select = 'Select',
    Common = 'Common questions',
    Application = 'Application support',
}

export const themesList = [Theme.Select, Theme.Common, Theme.Application];
